import React from 'react';
import {AutoField} from 'components/forms/fields';
import Section from 'components/forms/Section';
import useFieldData from 'components/forms/hooks/useFieldData';
import fields from 'components/forms/uscgtoss/fields';
import {Typography} from '@material-ui/core';
import {getInitialValues, getSchema} from 'components/forms/AutoSection';

const RankRating = ({...props}) => {
    const fieldDict = fields;
    const sectionFields = [
        'rank_type',
        'rank_E',
        'rank_CWO',
        'rank_O',
        'rating',
    ];
    const schema = getSchema(sectionFields, fieldDict);
    const initialValues = getInitialValues({}, sectionFields, fieldDict);
    const [type, setType] = useFieldData('rank_type', 'Enlisted');
    const updateType = e => {
        setType(e.target.value);
    };

    return (
        <Section {...props} schema={schema} initialValues={initialValues}>
            <Typography variant='h6' align='left'>
                Rank and Rating
            </Typography>
            <Typography variant='body1'>
                Now tell us about your time on this vessel and the positions you
                served. Start by entering your rating/rank for your first record
                on this vessel!
            </Typography>
            <AutoField
                field={fields['rank_type']}
                name='rank_type'
                onChange={updateType}
            />

            {type === 'Enlisted' ? (
                <AutoField field={fields['rank_E']} name='rank_E' />
            ) : null}
            {type === 'CWO' ? (
                <AutoField field={fields['rank_CWO']} name='rank_CWO' />
            ) : null}
            {type === 'Commissioned Officer' ? (
                <AutoField field={fields['rank_O']} name='rank_O' />
            ) : null}
            {type === 'Enlisted' || type === 'CWO' ? (
                // Update to select once ratings disambiguated
                <AutoField field={fields['rating']} name='rating' />
            ) : null}
            {props.children}
        </Section>
    );
};

export default RankRating;
